import styled from 'styled-components';

const LeactureNav = ({ navList, selectedNav, onNavClickHandler }) => {
  const doneCount = navList.filter((step) => step.completed).length;

  return (
    <Container>
      <Header>
        <Kicker>학습 단계</Kicker>
        <Title>다섯 단계</Title>
        <Progress>
          {doneCount}/{navList.length} 기록됨
        </Progress>
      </Header>
      <List>
        {navList.map((step) => (
          <Step
            key={step.id}
            type="button"
            $current={selectedNav === step.id}
            onClick={() => onNavClickHandler(step.id)}
          >
            <Num $current={selectedNav === step.id} $done={step.completed}>
              {String(step.id).padStart(2, '0')}
            </Num>
            <Copy>
              <StepTitle>{step.title}</StepTitle>
              <StepText>{step.subtitle}</StepText>
            </Copy>
          </Step>
        ))}
      </List>
    </Container>
  );
};

export default LeactureNav;

const Container = styled.nav`
  width: 280px;
  flex-shrink: 0;
  background: #fff;
  border: 1px solid #e7e1d3;
  border-radius: 4px;
  position: sticky;
  top: 84px;
  overflow: hidden;

  @media (max-width: 1024px) {
    position: static;
    width: 100%;
  }
`;

const Header = styled.div`
  padding: 18px 18px 14px;
  border-bottom: 1px solid #e7e1d3;
`;

const Kicker = styled.p`
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 600;
  color: #d9412b;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #1d2340;
`;

const Progress = styled.p`
  margin: 6px 0 0;
  font-size: 12px;
  color: #6f6a5c;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;

  @media (max-width: 1024px) {
    flex-direction: row;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const Step = styled.button`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 12px;
  text-align: left;
  color: #1d2340;
  background: ${({ $current }) => ($current ? '#fffbea' : 'transparent')};
  border: none;
  border-left: 3px solid ${({ $current }) => ($current ? '#d9412b' : 'transparent')};
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #f8f5ee;
  }

  @media (max-width: 1024px) {
    flex-shrink: 0;
    width: 180px;
    border-left: none;
    border-bottom: 3px solid ${({ $current }) => ($current ? '#d9412b' : 'transparent')};
  }
`;

const Num = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: ${({ $current, $done }) => ($current || $done ? '#d9412b' : '#a39c8a')};
`;

const Copy = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const StepTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.02em;
`;

const StepText = styled.span`
  font-size: 12px;
  line-height: 1.4;
  color: #6f6a5c;
`;
